import { combineReducers } from "redux";
import authReducer from "./auth/reducer";
import porfolioReducer from "./porfolio/reducer";
import uiReducer from "./ui/reducer";
import cartReducer from "./cart/reducer";
import cartReducerEP from "./educationalcart/reducer";

export const rootReducer = combineReducers(
{
    cart: cartReducer,
    educationalCart: cartReducerEP,
    auth: authReducer,
    porfolio: porfolioReducer,
    ui: uiReducer,
});

export type RootState = ReturnType<typeof rootReducer>;